// Shared CRM constants — mirror of backend routes/crm.py
export const CRM_STAGES = [
  { key: "new", label: "New", color: "#0044FF" },
  { key: "contacted", label: "Contacted", color: "#7C3AED" },
  { key: "qualified", label: "Qualified", color: "#0891B2" },
  { key: "quote_sent", label: "Quote Sent", color: "#D97706" },
  { key: "negotiation", label: "Negotiation", color: "#DB2777" },
  { key: "won", label: "Won", color: "#047857" },
  { key: "lost", label: "Lost", color: "#DC2626" },
  { key: "dormant", label: "Dormant", color: "#6B7280" },
];

export const STAGE_MAP = Object.fromEntries(CRM_STAGES.map((s) => [s.key, s]));
export const OPEN_STAGES = ["new", "contacted", "qualified", "quote_sent", "negotiation"];
export const ADMIN_ONLY_STAGES = ["won", "dormant"];

export const LOSS_REASONS = [
  { key: "price", label: "Price" },
  { key: "timing", label: "Timing" },
  { key: "competitor", label: "Went with competitor" },
  { key: "unresponsive", label: "Unresponsive" },
  { key: "out_of_area", label: "Out of area" },
  { key: "other", label: "Other" },
];

export const CRM_SOURCES = [
  { key: "web_form", label: "Web Form" },
  { key: "va_outreach", label: "VA Outreach" },
  { key: "referral", label: "Referral" },
  { key: "repeat_client", label: "Repeat Client" },
  { key: "inbound_call", label: "Inbound Call" },
  { key: "other", label: "Other" },
];

export const SERVICE_TYPES = [
  { key: "routine", label: "Routine cleaning" },
  { key: "deep", label: "Deep cleaning" },
  { key: "moveout", label: "Move-out cleaning" },
  { key: "apartment_turnover", label: "Apartment turnover" },
  { key: "carpet", label: "Carpet cleaning" },
  { key: "junk_removal", label: "Junk removal" },
  { key: "estate_cleanout", label: "Estate cleanout" },
  { key: "pressure_washing", label: "Pressure washing" },
  { key: "landscaping", label: "Landscaping" },
  { key: "handyman", label: "Handyman" },
  { key: "painting", label: "Painting" },
  { key: "maintenance_bundle", label: "Maintenance bundle" },
  { key: "commercial", label: "Commercial" },
  { key: "specialty_medical", label: "Specialty — medical" },
  { key: "specialty_funeral", label: "Specialty — funeral" },
  { key: "specialty_construction", label: "Specialty — construction" },
  { key: "product_sourcing", label: "Digital — product sourcing" },
  { key: "web_development", label: "Digital — web development" },
  { key: "app_development", label: "Digital — app development" },
  { key: "social_media_marketing", label: "Digital — social media" },
  { key: "seo_content", label: "Digital — SEO/content" },
  { key: "graphic_design", label: "Digital — graphic design" },
  { key: "digital_other", label: "Digital — other" },
  { key: "unknown", label: "Unknown / not set" },
];

export function fmtMoney(n) {
  const v = Number(n) || 0;
  return v >= 1000 ? `$${(v / 1000).toFixed(1)}k` : `$${v.toFixed(0)}`;
}

export function sourceLabel(key) {
  const s = CRM_SOURCES.find((x) => x.key === key);
  return s ? s.label : (key || "—").replace(/_/g, " ");
}

export function serviceLabel(key) {
  const s = SERVICE_TYPES.find((x) => x.key === key);
  return s ? s.label : (key || "—").replace(/_/g, " ");
}
